import { combineReducers } from "redux";
import { AuthReducer, UserReducer } from "./modules";

export default combineReducers({
  auth: AuthReducer,
  user: UserReducer,
});
